import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

const Table3 = ({ columns, data, setData, headerBg }) => {
  const handleToggle = (rowIndex, field) => {
    setData((prev) =>
      prev.map((row, index) => {
        if (index !== rowIndex) return row;

        const updatedRow = {
          ...row,
          [field]: !row[field],
        };

        return updatedRow;
      }),
    );
  };

  return (
    <div className="overflow-x-auto max-w-xl mt-4 rounded-t-xl">
      <Table>
        <TableHeader>
          <TableRow className={headerBg}>
            {columns.map((col) => (
              <TableHead key={col.key}>{col.label}</TableHead>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.length > 0 ? (
            data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                className="hover:bg-muted/50 border-b cursor-pointer"
              >
                {columns.map((col) => (
                  <TableCell key={col.key} className=" p-4">
                    {col.render
                      ? col.render(row, rowIndex, handleToggle)
                      : row[col.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                className="text-center py-6 text-muted-foreground "
              >
                No data found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default Table3;
